import { createAsyncThunk } from '@reduxjs/toolkit';
// api
import userNotificationsApi from '../../../api/userNotificationsApi';

import { NotificationTypeEnum } from '../../../constants/enums';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'userNotifications';

export const GetNotifications = createAsyncThunk(`${REDUCER_NAME}/getNotifications`, async (__, thunkAPI) => {
  const res = await userNotificationsApi.get({ type: NotificationTypeEnum.WebPush });

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetLastNotifications = createAsyncThunk(`${REDUCER_NAME}/getLastNotifications`, async (__, thunkAPI) => {
  const res = await userNotificationsApi.get({ type: NotificationTypeEnum.WebPush, limit: 10 });

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetFactoryLastNotifications = createAsyncThunk(
  `${REDUCER_NAME}/getFactoryLastNotifications`,
  async (__, thunkAPI) => {
    const res = await userNotificationsApi.getByFactory({ type: NotificationTypeEnum.WebPush, limit: 10 });

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetNotificationsTotalUnread = createAsyncThunk(`${REDUCER_NAME}/getTotalUnread`, async (__, thunkAPI) => {
  const res = await userNotificationsApi.getTotalUnread();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const MarkNotificationAsRead = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/markNotificationAsRead`,
  async (id, thunkAPI) => {
    const res = await userNotificationsApi.markAsRead(id);

    if (res.status === 200) {
      return id;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const MarkNotificationAsUnRead = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/markNotificationAsUnRead`,
  async (id, thunkAPI) => {
    const res = await userNotificationsApi.markAsUnRead(id);

    if (res.status === 200) {
      return id;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const MarkAllNotificationsAsRead = createAsyncThunk(
  `${REDUCER_NAME}/markAllNotificationsAsRead`,
  async (__, thunkAPI) => {
    const res = await userNotificationsApi.markAllAsRead();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
